import React from 'react'
import { Divider, Row, Form, Button, Input, Switch, notification } from 'antd'
import API from '../../services/API'
import Segment from '../../components/Segment'
import Search from '../../components/Search'
import { onKeyPressNumbers } from '../../services/Utils'
import { Link } from 'react-router-dom'


const INIT = {
    name: '',
    description: '',
    subsidiary_id: '',
    code: '',
    installed_date: '',
    installed_version: '',
    active: true,
}

const CheckoutsCreateContainer = () => {
    const [data, setData] = React.useState(INIT)
    const [loading, setloading] = React.useState(false)
    const [currentSubsidiary, setCurrentSubsidiary] = React.useState(false)
    const disabled = !data.name || !data.description || !data.code || !data.subsidiary_id

    const handleChange = (name, value) => {
        const newData = { ...data }
        newData[name] = value
        setData(newData)
    }

    const handleSubmit = e => {
        setloading(true)
        e.preventDefault()

        API.post('/api/checkouts', data)
            .then(() => {
                setloading(false)
                setData(INIT)
                notification.success({
                    message: 'La caja se ha creado exitosamente',
                })
            })
            .catch(error => {
                setloading(false)
                notification.error({ message: error.message })
            })
    }

    return (
        <Segment loading={loading}>
            <Divider>Crear caja</Divider>
            <Form style={{ maxWidth: '400px', margin: 'auto' }}>
                <p className="message">
                    Todos los campos marcados con un asterisco (<span>*</span>) son campos obligatorios y deben ser
                    llenados.
                </p>

                <Form.Item label="Código" className="required" hasFeedback>
                    <Input
                        placeholder="Código"
                        value={data.code}
                        onKeyPress={onKeyPressNumbers}
                        onChange={e => {
                            handleChange('code', e.target.value)
                        }}
                    />
                </Form.Item>
                <Form.Item label="Nombre" className="required" hasFeedback>
                    <Input
                        placeholder="Nombre"
                        value={data.name}
                        onChange={e => {
                            handleChange('name', e.target.value)
                        }}
                    />
                </Form.Item>

                <Form.Item label="Descripición" className="required" hasFeedback>
                    <Input
                        placeholder="Descripición"
                        value={data.description}
                        onChange={e => {
                            handleChange('description', e.target.value)
                        }}
                    />
                </Form.Item>

                <Form.Item label="Sucursal" className="required">
                    <Search
                        value={currentSubsidiary}
                        placeholder="Busca una sucursal"
                        onSearch={value => `/api/subsidiaries?filter[name]=${value}&filter[active]=1`}
                        onChange={(key, value) => {
                            handleChange('subsidiary_id', key)
                            setCurrentSubsidiary(value.name)
                        }}
                    />
                </Form.Item>

                <Form.Item label="Activo" hasFeedback>
                    <Switch
                        checked={!!data.active}
                        onChange={value => {
                            handleChange('active', value)
                        }}
                    />
                </Form.Item>


                <Row type="flex" justify="space-between" style={{ marginTop: '50px' }}>

                    <Form.Item>
                        <Link to="/checkouts">
                            <Button

                                icon="arrow-left"
                            >
                                Regresar
                            </Button>
                        </Link>
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            icon="save"
                            disabled={disabled}
                            onClick={handleSubmit}
                        >
                            Guardar
                        </Button>
                    </Form.Item>
                </Row>

            </Form>
        </Segment>
    )
}

export default CheckoutsCreateContainer
